<template>
	<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
		<div class="widget-location">
			<h3>배송지 주소록 설정</h3>
		</div>
		
		
		<div class="list-top">
			<div class="page-info">
				<span>전체 : <strong>{{total}}</strong></span>
			</div>
		</div>
		<el-table v-if="!isMobile" empty-text="데이터 없음"
		  :data="tableData" :header-cell-style="{ color: '#000' }"
		  style="width: 100%; margin-bottom: 20px;">
		  <el-table-column
			prop="consignee"
			width="150"
			label="수취인명" 
			>
		  </el-table-column>
		  <el-table-column
			prop="mobile"
			width="180"
			label="연락처"
			>
		  </el-table-column>
		  <el-table-column
			prop="customs_info"
			width="180"
			label="개인통관고유부호">
		  </el-table-column>
		  <el-table-column
			label="주소">
			<template slot-scope="scope">
				{{ scope.row.zipcode }} {{ scope.row.address }} {{ scope.row.detailed_address }} 
			</template>	
		  </el-table-column>
		    <el-table-column
		        fixed="right"
		        label="작업"
		        width="100">
		        <template slot-scope="scope">
		          <el-button  @click="editAddress(scope.row)" type="text" size="small">수정</el-button>
		          <el-button type="text" @click="deleteAddress(scope.row.id)" size="small">삭제</el-button>
		        </template>
		    </el-table-column>
		</el-table>
		<el-table v-else empty-text="데이터 없음"
		  :data="tableData" :show-header="false"
		  style="padding: 0 10px;width: 100%;margin-bottom: 20px;">
			  <el-table-column
			    label="">
				<template slot-scope="scope">
				  <p>{{ scope.row.consignee }}</p>
				  <p>개인통관고유부호:{{ scope.row.customs_info }}</p>
				  <p>{{ scope.row.mobile }}</p>
				  <p>[{{scope.row.zipcode}}] {{scope.row.address}} {{scope.row.detailed_address}}</p>
				</template>
				
			  </el-table-column>
			<el-table-column   
			    label="操作"
			    width="60">
			    <template slot-scope="scope">
			      <el-button  @click="editAddress(scope.row)" type="text" size="small">수정</el-button><br>
			      <el-button type="text" @click="deleteAddress(scope.row.id)" size="small">삭제</el-button>
			    </template>
			</el-table-column>	
		</el-table>
		
		<div class="btns-wrap">
			<el-button type="primary" size="medium" round @click="addAddress" >등록하기</el-button>	
		</div>
		
		<el-dialog title="배송지 주소록 등록" :visible.sync="dialogFormVisible" :width="isMobile?'90%':'50%'" :destroy-on-close="true" :close-on-click-modal="false" >
		  <el-form :model="form" :rules="rules" ref="form">
		    <el-form-item label="이름" prop="consignee" :label-width="formLabelWidth">
		      <el-input v-model="form.consignee" autocomplete="off"></el-input>
		    </el-form-item>
			<el-form-item label="영문 이름" prop="en_consignee" :label-width="formLabelWidth">
			  <el-input v-model="form.en_consignee" autocomplete="off"></el-input>
			</el-form-item>

			<el-row>
				<el-col :span="12" >
					<el-form-item  prop="areacode" label="휴대폰번호" :label-width="formLabelWidth">
						<el-select :style="isMobile?'width: 80px;':''" v-model="form.areacode" value-key="010" >
							<el-option v-for="item in areacode_options" :label="item.label" :value="item.value" :key="item.value"></el-option>
						</el-select>
					</el-form-item> 
				</el-col>
				<el-col :span="12" >
					<el-form-item  prop="mobile">
					     <el-input v-model="form.mobile" type="number" autocomplete="off"></el-input>
					   </el-form-item>
				</el-col>
			</el-row>	
			
			<el-form-item label="개인통관고유부호" prop="customs_info" :label-width="formLabelWidth">
			  <el-input v-model="form.customs_info" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="우편번호" prop="zipcode" :label-width="formLabelWidth">
			  <el-input v-model="form.zipcode" readonly autocomplete="off" placeholder="검색 버튼을 클릭하세요">
				<el-button slot="append" icon="el-icon-search" @click="searchPostcode">검색</el-button>
			  </el-input>
			</el-form-item>
			<el-form-item label="주소" prop="address" :label-width="formLabelWidth">
			  <el-input v-model="form.address" readonly autocomplete="off" placeholder="우편번호 검색 시 자동 입력됩니다"></el-input>
			</el-form-item>
			<el-form-item label="상세 주소" prop="detailed_address" :label-width="formLabelWidth">
			  <el-input v-model="form.detailed_address" autocomplete="off"></el-input>
			</el-form-item>
			
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="dialogFormVisible = false">취 소</el-button>
		    <el-button type="primary" @click="submit('form')">확 인</el-button>
		  </div>
		</el-dialog>
		
		
		
	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		data() {
			return{
				loading: true,
				total:'',
				tableData: [
					/* {
					consignee: '王小虎',
					mobile: '010-1112-3333',
					customs_info: 'P3243245345111',
					address:'上海市普陀区金沙江路 1518 弄',
					detailed_address:'3单元301',
					zipcode:124234
				  }, {
					consignee: '王小虎',
					mobile: '010-1112-3333	',
					customs_info: 'P3243245555111',
					address:'上海市普陀区金沙江路 1516 弄',
					detailed_address:'3单元302',
					zipcode:124234
				  }, {
					consignee: '王小虎',
					mobile: '010-1112-3333	',
					customs_info: 'P3243245345171',
					address:'上海市普陀区金沙江路 1515 弄',
					detailed_address:'3单元309',
					zipcode:124234
				  }, {
					consignee: '王小虎',
					mobile: '010-1112-3333',
					customs_info: 'P3243241234567',
					address:'上海市普陀区金沙江路 1513 弄',
					detailed_address:'2单元502',
					zipcode:124234
				  }, */
				],  
				dialogFormVisible: false,
				form: {
					id:'',
					consignee: '',
					en_consignee:'',
					mobile: '',
					areacode:'010',
					customs_info:'',
					zipcode:'',
					address:'',
					detailed_address:'',
					
				},
				rules: {
					consignee: [
					  { required: true, message: '필수', trigger: 'blur' },
					  // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
					],
					en_consignee: [
					  { required: true, message: '필수', trigger: 'blur' }
					],
					areacode: [
					  { required: true, message: '필수', trigger: 'change' }
					],
					mobile:[
						{ required: true, message: '필수', trigger: 'blur' },
						{ validator: (rule, value, callback) => {
							const regex = /^\d{7,8}$/;		
							if (!regex.test(value)) {
							  callback(new Error('핸드폰 번호의 형식이 정확하지 않다.'));
							} else {
							  callback();
							}
						}, trigger: 'blur' }
					],
					zipcode: [
					  { required: true, message: '필수', trigger: 'blur' },
					  { validator: (rule, value, callback) => {
					  	const regex = /^\d{5,6}$/;		
					  	if (!regex.test(value)) {
					  	  callback(new Error('우편 번호 형식이 잘못되었습니다.'));
					  	} else {
					  	  callback();
					  	}
					  }, trigger: 'blur' }
					],
					address: [
					  { required: true, message: '필수', trigger: 'blur' }
					],
					customs_info: [
					  { required: true, message: '필수', trigger: 'blur' },
					  { validator: (rule, value, callback) => {
					  	const regex = /^[pP]\d{12}$/;		
					  	if (!regex.test(value)) {
					  	  callback(new Error('개인통관고유부호 형식이 잘못되었습니다. (P로 시작하는 13자리)'));
					  	} else {
					  	  callback();
					  	}
					  }, trigger: 'blur' }
					]
				
				},
				formLabelWidth: '95px',
				areacode_options: [
					{
						value: '010',
						label: '010'
					},{
						value: '011',
						label: '011'
					},{
						value: '016',
						label: '016'
					},{
						value: '017',
						label: '017'
					},{
						value: '018',
						label: '018'
					},{
						value: '019',
						label: '019'
					}
				]
				
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},
		created() {
			this.getList()
		},
		methods: {
			editAddress(row) {
				console.log(row.id,"修改");
				if(row.id){
					this.form.id = row.id
					this.getAddressDetail()
				}
				this.dialogFormVisible = true
			},
			getAddressDetail(){
				request.post('/member/Address/getAddressDetail',
					{id:this.form.id}
				).then(res => {
					console.log(res,"资料")			  
					if(res.code ==1){
						this.form= res.data
			
						
					}else{
						alert(res.msg)
						return
					}	
				});
				
			},
			addAddress(){
				console.log("添加")
				this.form = {areacode:'010'}
				this.dialogFormVisible = true
			},
			deleteAddress(id){
				console.log(id,"删除")
				 this.$confirm('정말 1개의 데이타를 삭제하겠습니까?', '경고', {
					  confirmButtonText: '확인',
					  cancelButtonText: '취소',
					  type: 'warning'
					}).then(() => {
						request.post('/member/Address/delAddress',
							{
								id:id,
							}
						).then(res => {
							console.log(res,"列表")
							if(res.code ==1){
								this.$message({
									type: 'success',
									message: res.msg
								});
								//this.$router.go(0)
								this.getList()
							}
								
						});
						
					
					}).catch(() => {
					     
					});
				
				
			},
			getList(){
				this.loading = true
				request.post('/member/Address/addressList',
					{
						//page:this.page,
					}
				).then(res => {
					this.loading = false
					console.log(res,"列表")
					if(res.code ==1){
						this.total = res.data.length
						this.tableData= res.data
					}
						
				}).catch(() => {
					this.loading = false
				});
			},
			submit(formName){				
				console.log(this.form,"已提交")
				this.$refs[formName].validate((valid) => {
				  if (valid) {
					 //  if(this.form.id){
						// console.log("修改！！！！")
					  	
					 //  }else{
					  	request.post('/member/Address/addAddress',
					  		this.form
					  	).then(response => {
					  		console.log(response,"返回")			  
					  		if(response.code ==1){
					  			alert('제출 성공！');
					  			this.dialogFormVisible = false				
					  			this.getList()
					  			
					  		}else{
					  			alert(response.msg)
					  			return
					  		}	
					  	});
					  // }
						
 					
				  } else {
					console.log('error submit!!');
					return false;
				  }
				});
			}
			,
			searchPostcode() {
				new window.daum.Postcode({
					oncomplete: (data) => {
						// data.zonecode: 邮政编码（5位）
						// data.address: 基本地址（道路名 或 地号）
						// data.roadAddress: 道路名地址
						// data.jibunAddress: 地号地址
						this.$set(this.form, 'zipcode', data.zonecode);
						this.$set(this.form, 'address', data.roadAddress || data.address);
						
						// 聚焦到详细地址输入框
						this.$nextTick(() => {
							const detailInput = this.$refs.form ? this.$refs.form.$el.querySelector('[prop="detailed_address"] input') : null;
							if (detailInput) detailInput.focus();
						});
					}
				}).open();
			}
		}
	}
</script>

<style scoped>
	.widget-location {
	    margin-top: 50px;
	    margin-bottom: 60px;
	    text-align: center;
	}
	.widget-location h3 {
	    padding: 0;
	    margin: 0;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	}
	.list-top {
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    margin-bottom: 40px;
	}
	.list-top .page-info{
		padding-left: 10px;
	}
	.btns-wrap{
		display: flex;justify-content: end;align-items: center; margin-bottom: 30px;
	}

	

	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.content-zsy{
			padding:0 10px;
		}
		.widget-location {
		    text-align: center;
		    margin-top: 50px;
		    margin-bottom: 30px;
		}
		.widget-location h3 {
		    font-size: 30px;
		    font-weight: bold;
		    margin: 0;
		    word-break: keep-all;
		}
	
	
	
	}
</style>